﻿import FavoriteImagesApi from '../FavoriteImagesApi';

export function getAllFavoriteImages(page: number, photographerId?: number) {
    return FavoriteImagesApi.getFavoriteImages(page, photographerId);
}
